export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "firstCall": {
          "inputTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter destination"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter a phone number, username (a user of your application), or SIP address. To process the call correctly, it is necessary that the specified type corresponds to the scenario logic"])},
          "buttonMain": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Call"])},
          "buttonVideoCall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Video Call"])}
        },
        "toneDial": {
          "inputTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numpad"])},
          "buttonMain": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["End call"])},
          "buttonAdditional": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back"])}
        },
        "newCall": {
          "inputTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New Call"])},
          "buttonMain": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Call"])},
          "buttonAdditional": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back"])}
        },
        "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Specify whom you want to call"])},
        "buttonVideoCall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Video Call"])}
      },
      "ru": {
        "firstCall": {
          "inputTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Адресат звонка"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введите номер телефона, имя пользователя (пользователя вашего приложения) или SIP-адрес. Для корректной обработки звонка необходимо, чтобы указанный тип соответствовал логике сценария"])},
          "buttonMain": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Позвонить"])},
          "buttonVideoCall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Видео"])}
        },
        "toneDial": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Панель набора"])},
          "buttonMain": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Завершить"])},
          "buttonAdditional": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скрыть панель"])}
        },
        "newCall": {
          "inputTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Новый звонок"])},
          "buttonMain": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Позвонить"])},
          "buttonAdditional": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Назад"])}
        },
        "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Укажите, кому вы хотите позвонить"])},
        "buttonVideoCall": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Видео"])}
      }
    }
  })
}
